import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import Vue3Toastify from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import './assets/global.css'

const app = createApp(App)
app.use(router)
app.use(Vue3Toastify, { autoClose: 4000, position: 'top-right' })
app.mount('#app')
